import { render } from "./Delvast.vue?vue&type=template&id=21391e63"
import script from "./Delvast.vue?vue&type=script&lang=js"
export * from "./Delvast.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__